export enum ConditionalRuleKind {
  EQUALS = 'equals',
  IS_LESS_THAN = 'is less than',
  IS_GREATER_THAN = 'is greater than',
  IS_BETWEEN = 'is between',
  IS_NOT_BETWEEN = 'is not between'
}

export interface ConditionalRule {
  kind: ConditionalRuleKind;
  value: string;
}

export interface ConditionalRuleConfig {
  id: string;
  rule: string;
  utilize: string;
  value1: number;
  value2: number;
}

export interface RulesEngineProps {
  fieldId: string;
  fieldName: string;
  isReadOnlyView: boolean;
  updateRules: (options: ConditionalRuleConfig[]) => void;
}
